import { useState } from "react";

const initialStatebox = {
  ejercicioinicio: 0,
  ejerciciofin: 0,
  periodoinicio: 0,
  periodofin: 0,
  ejercicio: new Date().getFullYear(), 
  periodo: new Date().getMonth() + 1,
  filtrado: "",
  linea: 0,
  titulosucursal: "",
  titulodepartamento: "",
  arrayadr: [],
  arraysucursal: [],
  arraydepartamento: [],
  pv: { adr: [], sucursal: [], departamento: [] },
};
export const useBox = (initialState = initialStatebox) => {
  const [boxstate, setBoxState] = useState(initialState);

  const BoxChange = (name, value) => {
    setBoxState({
      ...boxstate,
      [name]: value,
    });
  };

  return [boxstate, BoxChange, setBoxState];
};

export const useBoxFiltros = (initialState = initialStatebox) => {
  const [boxstate, setBoxState] = useState(initialState);

  const BoxChange = (name, value) => {
    setBoxState({
      ...boxstate,
      [name]: value,
    });
  };

  return [boxstate, BoxChange];
};
